<template>
  <div>
    <b-card header="Interesses">
      <b-row>
        <div>
          <b-col xl="12" md="12" sm="12">
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="adicionarImagem"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar interesse
            </b-button>
          </b-col>
        </div>
        <div>
          <b-col xl="12" md="12" sm="12">
            <nav>
              <b-pagination
                :total-rows="getRowCount(items)"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Anterior"
                next-text="Próxima"
                hide-goto-end-buttons
              />
            </nav>
          </b-col>
        </div>
      </b-row>
      <b-card class="text-center f-g" v-if="items.length <= 0">
        <i class="fa fa-frown-o fa-custom-size"></i>
        <h4>Desculpe, não encontramos nenhum interesse :(</h4>
      </b-card>
      <b-table
        :items="items"
        :fields="fields"
        v-if="items.length > 0"
        bordered
        striped
        hover
        responsive="sm"
        :current-page="currentPage"
        :per-page="perPage"
        @row-clicked="editarImagem"
      >
        <template v-slot:cell(description)="data">
          <h5 class="texto-descricao">{{ data.item.description }}</h5>
        </template>
        <template v-slot:cell(imageUrl)="data">
          <img
            v-if="data.item.imageUrl != null"
            :src="data.item.imageUrl"
            alt="Thumbnail"
            class="center-image"
            height="200px"
            width="250px"
          />
          <span v-else class="texto-imagem-interesse">
            <small>Sem imagem.</small>
          </span>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "interesses",
  components: {
    Loading,
  },
  data: function () {
    return {
      items: [],
      fields: [
        { key: "id", label: "Código" },
        { key: "description", label: "Descrição" },
        { key: "imageUrl", label: "Imagem" },
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
    };
  },
  methods: {
    redirect(ref) {
      if (ref == "Adicionar") {
        this.$router.push(`/interesses/Adicionar`);
        this.descricao = localStorage.getItem("desc_interesse");
        this.imageSource = localStorage.getItem("img_interesse");
      }
    },
    async getInteresses() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-interesses-por-empresa/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });
        if (response.status == 200) {
          this.items = response.data.data;
        }
      } catch (error) {
        console.log({ error });
      }
    },

    getRowCount(items) {
      return items.length;
    },

    adicionarImagem() {
      localStorage.removeItem("desc_interesse");
      localStorage.removeItem("img_interesse");
      localStorage.removeItem("id_interesse");
       localStorage.removeItem("totalCustomers");
      this.$router.push(`/interesses/adicionar`);
    },

    editarImagem(record) {
      localStorage.setItem("desc_interesse", record.description);
      localStorage.setItem("img_interesse", record.imageUrl);
      localStorage.setItem("id_interesse", record.id);
      localStorage.setItem("totalCustomers", record.totalCustomers);
      this.$router.push(`/interesses/editar`);
    },
  },
  beforeMount() {
    this.getInteresses();
  },
};
</script>

